<template>
    <v-app id="confirm" class="primary general-form-wrapper">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <template v-if="status === 1">
                            <v-card class="elevation-1 pa-3 text-xs-center">
                                <v-card-text class="py-0 pt-2">
                                    <v-icon size="64" color="success">fa-check</v-icon>
                                </v-card-text>
                                <v-card-text color="success" class="py-2">
                                    <h3 class="notification-header success--text">{{$t('general.success')}}</h3>
                                </v-card-text>
                                <v-card-text>
                                    <p>{{$t('registration.msg_registration_success')}}</p>
                                </v-card-text>
                            </v-card>
                        </template>
                        <template v-else-if="status === -1">
                            <v-card class="elevation-1 pa-3 text-xs-center">
                                <v-card-text class="py-0 pt-2">
                                    <v-icon size="64" color="error">fa-times</v-icon>
                                </v-card-text>
                                <v-card-text color="error" class="py-2">
                                    <h3 class="notification-header error--text">{{$t('general.fail')}}</h3>
                                </v-card-text>
                                <v-card-text v-if="error">
                                    <p>{{error}}</p>
                                </v-card-text>
                            </v-card>
                        </template>
                        <template v-else>
                            <v-card class="elevation-1 pa-3 text-xs-center">
                                <v-card-text class="py-0 pt-2">
                                    <v-progress-circular
                                        :size="64"
                                        :width="7"
                                        color="warning"
                                        indeterminate
                                    ></v-progress-circular>
                                </v-card-text>
                                <v-card-text color="warning" class="py-2">
                                    <h3 class="notification-header warning--text">{{$t('general.processing')}}</h3>
                                </v-card-text>
                            </v-card>
                        </template>
                        <div class="text-xs-center">
                            <v-btn flat color="primary" :to="{name: 'public_login'}">{{$t('login.button')}}</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices, BACKEND_URL} from '~/utils/url-manager'
    export default {
        data() {
            return {
                status: 0,   // 0 => pending, 1 => success, -1 => fail
                error: ''
            }
        },
        computed: {
        },
        methods: {
            verify() {
                let me = this;
                let params = {
                    t: me.$route.query.t
                };
                RequestHandler.Post(UrlServices.createUrl({'name': 'api_confirm'}), params, {
                    'success': function(data){
                        //console.log('success', data);
                        me.status = 1;
                    },
                    'error': function(error) {
                        //console.log('error', error);
                        me.status = -1;
                        me.error = error;
                    }
                });
            }
        },
        mounted: function() {
            this.verify();
        }
    };
</script>
<style scoped>

</style>
